import dischargeStatusCodes from "./dischargeStatusCodes.json";

interface DischargeStatusCode {
  code: string;
  description: string;
}

const dischargeStatusByCode = new Map<string, string>(
  (dischargeStatusCodes as DischargeStatusCode[]).map((entry) => [
    entry.code,
    entry.description,
  ]),
);

export const formatDischargeStatus = (code: unknown): string => {
  if (typeof code !== "string" || code === "") return "";
  const description = dischargeStatusByCode.get(code);
  return description ? `${code} - ${description}` : code;
};
